<template>
	<div>
		<Sounds />
	</div>
</template>

<script>
import Sounds from '@/components/Sounds';

export default {
	components: {
		Sounds
	}
}
</script>
